import React from "react";
import { BrowserRouter } from "react-router-dom";
import { toast } from "react-toastify";
import AppRoutes from "./routes";

import "./App.css";
// Toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import ScrollToTop from "./components/scrollTop";

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
        <ToastContainer limit={1} />
      </BrowserRouter>
    </Provider>
  );
};

export default App;
